// extracted by mini-css-extract-plugin
export var productAccessHeader = "product-access-header_owg8DWbgFeWyDclCrqhK";